module.exports = __webpack_public_path__ + "img/anonymous-avatar.1b33be95.png";